import { useQuery } from "react-query";
import { Link, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

import Dropdown, {
  DropdownMenu,
  DropdownMenuOption,
} from "../../components/Buttons/Dropdown";
import SearchBar from "../../components/Inputs/SearchBar";
import Table, { IPaginationProps, ITableHeader } from "../../components/Table";
import Title from "../../components/Title";
import { ProductCartService } from "../../services/product-carts";
import { formatCurrency } from "../../utils/formatter";
import { useTableQueryParams } from "../../hooks/router";
import { Button } from "react-bootstrap";

let timerId: any;

function CartTab() {
  const intl = useIntl();
  const { id } = useParams();
  const { page, search, setParam, size } = useTableQueryParams();

  const options: DropdownMenuOption<any>[] = [
    {
      text: intl.formatMessage({ id: "See detail" }),
      icon: "ni ni-eye",
      link: (entity) => `/products/${entity.product.id}?t=info`,
    },
    // {
    //   type: "divider",
    // },
    // {
    //   icon: "ni ni-shield-star",
    //   text: intl.formatMessage({ id: "Change Status" }),
    //   link: (entity) => `/order/${entity.id}`,
    // },
    // {
    //   icon: "ni ni-na",
    //   text: intl.formatMessage({ id: "ACTIONS.CANCEL" }),
    //   link: (entity) => `/order/${entity.id}`,
    // },
  ];

  const { data, isLoading } = useQuery(
    ["productCartList", search, page, size],
    () => {
      return ProductCartService.getDetails(id as string);
    },
  );

  const headers: ITableHeader[] = [
    {
      path: ["product", "name"],
      name: intl.formatMessage({ id: "Product" }),
      className: "lg-table-col",
      transform: (value, obj) => {
        return (
          <Link to={`/products/${obj.id}?t=info`}>
            <Button as="span" variant="link" className="tb-product">
              {obj?.product?.mediaAssets?.length ? (
                <img
                  src={
                    obj?.product.mediaAssets[0].thumbnail ||
                    obj.mediaAssets[0]?.url
                  }
                  alt={`image-${value}`}
                  className="thumb"
                />
              ) : null}
              <span className="title text-primary">{value}</span>
            </Button>
          </Link>
        );
      },
    },
    {
      path: ["qty"],
      name: intl.formatMessage({ id: "Quantity" }),
    },
    {
      path: ["product", "price"],
      name: intl.formatMessage({ id: "priceHeader" }),
      transform: formatCurrency,
    },
    {
      path: ["options"],
      name: "",
      type: "tools",
      transform: (v, entity) => (
        <Dropdown
          key={entity.id}
          icon
          trigger
          text={<em className="icon ni ni-more-h" />}
        >
          <DropdownMenu options={options} entity={entity} />
        </Dropdown>
      ),
    },
  ];

  const pagination: IPaginationProps = {
    current: Number(page) || data?.pagination?.page,
    size: Number(size) || data?.pagination?.size,
    total: data?.pagination?.total,
    onPageChange(page) {
      setParam("page", String(page));
    },
    onSizeChange(size) {
      setParam("size", String(size));
    },
  };

  console.log(data);

  const onSearch = (term: string) => {
    clearTimeout(timerId);
    timerId = setTimeout(
      () => {
        setParam("search", term);
      },
      Number(process.env.REACT_APP_SEARCH_DELAY || 700),
    );
  };

  return (
    <div className="container-fluid">
      <div className="nk-content-inner">
        <div className="nk-content-body">
          <Title
            subText={intl.formatMessage(
              { id: "You have a total of N products." },
              { number: data?.pagination?.total || 0 },
            )}
            rightContent={
              <ul className="nk-block-tools g-3">
                <li>
                  <SearchBar onChange={(e) => onSearch(e.target.value)} />
                </li>
              </ul>
            }
          >
            <FormattedMessage id="Product Cart list" />
          </Title>

          <div className="nk-block">
            {isLoading ? (
              <div className="text-center">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <div className="spinner-grow" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <Table
                headers={headers}
                data={data?.data || []}
                /*   selectable */
                loading={isLoading}
                pagination={pagination}
                /*    bulkOptions={[
                  { icon: "ni ni-na", text: intl.formatMessage({ id: "Disable all" }) },
                  { icon: "ni ni-trash", text: intl.formatMessage({ id: "Delete all" }) },
                  { icon: "ni ni-shield-star", text: intl.formatMessage({ id: "Reset all" }) },
                ]} */
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartTab;
